import React from 'react'
import PropTypes from 'prop-types'
import PartnerSiteRedirect from '.'
import { useFlags } from 'launchdarkly-react-client-sdk'


const PartnerSiteRedirectWrapper = (props) => {
  const { enableXact, redirectToP360 } = useFlags()
  const { brand, redirectToBrand, authProps, isAppRedirect, isInline, loanDetails } = props
  return (
    <PartnerSiteRedirect
      brand={brand}
      redirectToBrand={redirectToBrand}
      authProps={authProps}
      enableXact={enableXact}
      redirectToP360={redirectToP360}
      isAppRedirect={isAppRedirect}
      location={document.location}
      isInline={isInline}
      loanDetails = {loanDetails}
    />
  )
}

PartnerSiteRedirectWrapper.propTypes = {
  brand: PropTypes.string,
  isInline: PropTypes.bool,
  redirectToBrand: PropTypes.string,
  loanDetails: PropTypes.object,
  authProps: PropTypes.shape({
    isAdmin: PropTypes.bool.isRequired,
  }),
  isAppRedirect: PropTypes.bool,
}

export default PartnerSiteRedirectWrapper
